<template>
  <div>
    <div class="sm:hidden mb-2 sm:mb-0 flex items-center">     
      <select class="defaultInput" @change="selectTab($event.target.value)">
        <option v-for="tab in tabs" :key="tab.name" :value="tab.name">{{ getTabLabel(tab) }}</option>
      </select>
      <div class="px-2" v-if="hasDefaultSlot">
        <slot />
      </div>
    </div>
    
    <div class="hidden sm:block sm:pb-4">
      <div class="flex justify-between items-center border-b border-gray-200">
        <nav class="tabs-nav overflow-x-auto -mb-px flex gap-4 " aria-label="Tabs">
          <a v-for="tab in tabs"
            :key="tab.name"
            @click="select(tab.name)"
            class="tab group inline-flex items-center gap-2 py-1 border-b-4 font-light truncate"
            :class="[tab.current ? 'border-gray-600 text-gray-800' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300']"
            :aria-current="tab.current ? 'page' : undefined">
          
            <span :class="`text-${size}`" class=" ">{{ getTabLabel(tab) }}</span>


            <div v-if="tab.notification > 0">
              <slot name="badge" />
            </div>            
          </a>
        </nav>

        <div class="px-2">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name: "Tabs",

    props: {
        tabs: Array,
        tabSelect: Function,
        currentTab: {
            type: String,
            default: null,
            required: false
        },
        size: {
          type: String,
          default: 'xss',
          required: false
        }
    },
    
    data() {
        return {
          selectedTab: '',
          selectedTabMobille: '',
        }
    },

    computed: {
      hasDefaultSlot () {
        return !!this.$slots.default;
      },
    },

    methods: {    
      selectTab(tab) {
        this.tabSelect(tab)
      },

      select(tabName) {
          this.tabs.forEach(tab => {
              if (tab.name == tabName) {
                  tab.current = true;
                  this.selectedTab = tab.tabName;
              } else {
                  tab.current = false;
              }
          });
          this.tabSelect(tabName);
      },

      replaceSpace(string){
          // remove , . -
          string = string.replace(/[,.-]/g, "");
          return string.replace(/ /g, '_');
      },

      getTabLabel(tab) {
          const translationKey = `tabs.${this.replaceSpace(tab.name).toLowerCase()}`;
          const translated = this.$t(translationKey);

          // Se a tradução retornar a própria chave, usa o label ou o name
          if (translated === translationKey) {
              return tab.label || tab.name;
          }
          return translated;
      }
    },

    watch: {
        tabs: {
            handler: function (val) {

              // Isso vai causar select multiple
              //console.log("atualizou as tabs")

                // if (this.currentTab) {
                //     this.select(this.currentTab);
                // } else {
                //     this.select(val[0].name);
                // }
            },
            deep: true
        },

        currentTab: function(newVal, oldVal) {         
            if(newVal == oldVal) { return };
            //console.log("chamou o select watch")
            // Está enviando 2 requisições
            //this.select(newVal);
            this.tabs.forEach(tab => {
              if (tab.name === newVal) {
                  tab.current = true;
                  this.selectedTab = tab.tabName;
              } else {
                  tab.current = false;
              }
          });
        },

    },
    created() {
      const current = this.tabs.find((t) => t.name === this.currentTab);

      if (current) {
        this.select(current.name);
      } else {
        if(this.tabs && this.tabs.length > 0) {
           if(this.currentTab) {
             this.select(this.currentTab);
           } else {
             this.select(this.tabs[0].name);
           }
        }
        else {
           this.select('Error no tabs');
        }
      }
    },

}
</script>

<style scoped>
.tabs-nav {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
}

.tabs-nav::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

.tab {
  flex: 0 0 auto;
}
</style>